import { Box, Center, Image } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import VSpinner from '../VSpinner';
import { SIGNATURE_PAD_ASPECT_RATIO } from './VSignature.helpers';

export interface StoredSignatureProps {
  signature?: Blob;
}

export const StoredSignature = ({ signature }: StoredSignatureProps) => {
  const signatureUrl = useMemo(
    () => (signature ? URL.createObjectURL(signature) : null),
    [signature]
  );

  useEffect(() => {
    if (!signatureUrl) {
      return;
    }

    return () => URL.revokeObjectURL(signatureUrl);
  }, [signatureUrl]);

  const [settledUrl, setSettledUrl] = useState<string | null>(null);
  const isLoading = signatureUrl !== null && signatureUrl !== settledUrl;

  return (
    <Box
      width="100%"
      aspectRatio={SIGNATURE_PAD_ASPECT_RATIO}
      borderWidth="1px"
      borderColor="border"
      rounded="md"
      background={'bg.subtle'}
      position="relative"
    >
      {isLoading && (
        <Center position="absolute" inset={0}>
          <VSpinner />
        </Center>
      )}
      {signatureUrl && (
        <Image
          src={signatureUrl}
          alt="Signature"
          width="100%"
          onLoad={() => setSettledUrl(signatureUrl)}
          onError={() => setSettledUrl(signatureUrl)}
        />
      )}
    </Box>
  );
};
